// API для работы с backend
const API_URL = (import.meta as any).env?.VITE_API_URL || 'http://localhost:8000'

interface OrderNotification {
  user_id: number
  order_id: string
  total: number
  items_count: number
  status: 'pending' | 'confirmed' | 'cancelled' | 'paid'
}

export const notifyOrderStatus = async (notification: OrderNotification): Promise<boolean> => {
  try {
    const response = await fetch(`${API_URL}/api/notify-order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(notification),
    })

    if (!response.ok) {
      console.error('❌ Ошибка API:', response.status, response.statusText)
      return false
    }

    const data = await response.json()
    console.log('✅ Уведомление отправлено:', data)
    return data.success
  } catch (error) {
    console.error('❌ Ошибка при отправке уведомления:', error)
    console.error('⚠️ Проверьте что backend запущен: cd backend && python api.py')
    return false
  }
}

export const notifyPayment = async (notification: OrderNotification): Promise<boolean> => {
  try {
    const response = await fetch(`${API_URL}/api/notify-payment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(notification),
    })

    if (!response.ok) {
      console.error('❌ Ошибка API:', response.status, response.statusText)
      return false
    }

    const data = await response.json()
    console.log('✅ Уведомление об оплате отправлено:', data)
    return data.success
  } catch (error) {
    console.error('❌ Ошибка при отправке уведомления об оплате:', error)
    console.error('⚠️ Проверьте что backend запущен: cd backend && python api.py')
    return false
  }
}

// Получить ID текущего пользователя из Telegram WebApp
export const getCurrentUserId = (): number | null => {
  try {
    const webApp = (window as any).Telegram?.WebApp
    return webApp?.initDataUnsafe?.user?.id || null
  } catch {
    return null
  }
}
